const API_URL = "https://interni.sacelman.it/API/user"; // Cambia con l'URL della tua API

const authProvider = {
  // **LOGIN** - Chiamata API per autenticare l'utente
  login: async ({ username, password }) => {
    const request = new Request(`${API_URL}/login`, {
      method: "POST",
      body: JSON.stringify({ code: username, password }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Sacel-Shared-Key": "S4c3lM0b1leApPK3y..10",
      },
    });

    const response = await fetch(request);
    if (response.status === 200) {
      const data = await response.json();
      localStorage.setItem("auth", JSON.stringify({ user: data.params }));
      return Promise.resolve();
    }

    return Promise.reject(new Error("Credenziali errate"));
  },

  getUser: () => {
    let auth = localStorage.getItem("auth");
    if (auth) {
      auth = JSON.parse(auth);
      return auth.user;
    } else {
      return null;
    }
  },

  getDemo: async () => {
    let auth = localStorage.getItem("auth");
    let id = null;
    if (auth) {
      auth = JSON.parse(auth);
      if (
        auth.user.role === "ADMIN" ||
        auth.user.role === "SELLER_SIMPLEMAN" ||
        auth.user.role === "MARKETING"
      ) {
        return Promise.resolve(null);
      }

      id = auth.user.id;
    } else {
      return Promise.reject(new Error("Sessione scaduta"));
    }

    const request = new Request(`${API_URL}/getSimplemanDemo`, {
      method: "POST",
      body: JSON.stringify({ id_user: id }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Sacel-Shared-Key": "S4c3lM0b1leApPK3y..10",
      },
    });

    const response = await fetch(request);
    if (response.status === 200) {
      const data = await response.json();
      if (!data.params) {
        return Promise.reject(new Error("Demo non attiva"));
      }

      let now = new Date();
      if (new Date(data.params.expiration) < now) {
        return Promise.reject(new Error("Demo scaduta"));
      }

      return Promise.resolve(data.params);
    }

    return Promise.reject(new Error("Credenziali errate"));
  },

  saveDemoSecondsRemaining: async seconds => {
    let auth = localStorage.getItem("auth");
    let id = null;
    if (auth) {
      auth = JSON.parse(auth);
      id = auth.user.id;
    } else {
      return Promise.reject(new Error("Sessione scaduta"));
    }

    const request = new Request(
      `${API_URL}/saveSimplemanDemoSecondsRemaining`,
      {
        method: "POST",
        body: JSON.stringify({ id_user: id, seconds_remaining: seconds }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Sacel-Shared-Key": "S4c3lM0b1leApPK3y..10",
        },
      }
    );
    const response = await fetch(request);
    if (response.status === 200) {
      return Promise.resolve();
    } else {
      return Promise.reject(new Error("Errore"));
    }
  },

  setTutorialCompleted: async () => {
    let auth = localStorage.getItem("auth");
    let id = null;
    if (auth) {
      auth = JSON.parse(auth);
      id = auth.user.id;
    } else {
      return Promise.reject(new Error("Sessione scaduta"));
    }

    const request = new Request(
      `${API_URL}/setSimplemanDemoTutorialCompleted`,
      {
        method: "POST",
        body: JSON.stringify({ id_user: id }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Sacel-Shared-Key": "S4c3lM0b1leApPK3y..10",
        },
      }
    );
    const response = await fetch(request);
    if (response.status === 200) {
      return Promise.resolve();
    } else {
      return Promise.reject(new Error("Errore"));
    }
  },

  // **LOGOUT** - Rimuove il token
  logout: () => {
    localStorage.removeItem("auth");
    return Promise.resolve();
  },

  // **CONTROLLO AUTENTICAZIONE** - Verifica se l'utente è loggato
  checkAuth: () => {
    return localStorage.getItem("auth") ? Promise.resolve() : Promise.reject();
  },

  // **CONTROLLO ERRORI** - Gestisce errori API (es. token scaduto)
  checkError: error => {
    if (error.status === 401 || error.status === 403) {
      localStorage.removeItem("auth");
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getPermissions: async () => {
    console.log("Get permissions chiamato");
    return Promise.resolve();
  },
};

export default authProvider;
